module.exports = __webpack_public_path__ + "static/media/Orientation1.73701c70.jpeg";